export default __webpack_public_path__ + "static/media/apple-store.e7efa6e5.png";